<template>
    <div>
        <b-sidebar id="sidebar-backdrop" sidebar-class="columns-sidebar" :backdrop-variant="'dark'" backdrop shadow
            :visible="showColumns" :right="true" no-header-close no-close-on-backdrop no-close-on-esc>
            <template #header="{ }">
                <div class="d-flex align-items-center w-100 justify-content-between">
                    <div class="d-flex align-items-center w-100 mr-2">
                        <div class="text-nowrap">
                            {{ $t('tableColumns.title') }}
                        </div>
                    </div>
                </div>
            </template>
            <div class="mt-3">
                <draggable v-model="columnFields" :element="'div'" ghost-class="ghost" @change="getUpdatedFieldsList()">
                    <div class="px-4" :class="index + 1 === columnFields.length ? 'mb-7rem':'mb-3'" v-for="(field, index) in columnFields" :key="index">
                        <div
                            :class="`align-items-center justify-content-between cursor-pointer ${field.key === '#' ? 'd-none' : 'd-flex'}`">
                            <b-form-checkbox class="pl-0" :id="'checkbox-' + index" v-model="field.visible" :disabled="field.disabled"
                                @change="updateFields()" :name="'checkbox-' + index" @click.native.capture.stop>
                                {{ field.label }}
                            </b-form-checkbox>
                            <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="2" cy="16" r="2" transform="rotate(-90 2 16)" fill="#C4C4C4" />
                                <circle cx="2" cy="9" r="2" transform="rotate(-90 2 9)" fill="#C4C4C4" />
                                <circle cx="2" cy="2" r="2" transform="rotate(-90 2 2)" fill="#C4C4C4" />
                            </svg>
                        </div>
                        <hr />
                    </div>
                </draggable>
            </div>
            <div class="sidebar-footer position-fixed">
                <div class="d-flex justify-content-between modal-footer border-0 p-0">
                    <button type="button" class="btn mx-0 h-40px w-100px btn-outline-primary"
                    @click="$emit('resetTableFields')"
                    >{{ $t('tableColumns.reset') }}</button>
                    <b-button class="mx-0 h-40px w-100px" :variant="defaultView || !viewColumns ? 'secondary' : 'primary'" @click="columnFields = []; $emit('resetData');">{{ defaultView || !viewColumns ? $t('tableColumns.close') : $t('tableColumns.save') }}</b-button>
                </div>
            </div>
        </b-sidebar>
    </div>
</template>
<script>
import draggable from 'vuedraggable'
export default {
    data() {
        return {
            columnFields: [],
            suppressMerge: false,
        }
    },
    name: "TableColumns",
    props: ['showColumns', 'fields', 'viewColumns', 'defaultView'],
    components: { draggable },
    watch: {
        showColumns() {
            if (this.showColumns) {
                this.columnFields = this.mergeFieldsWithView();
            }
        },
        viewColumns: {
            handler() {
                // Skip if this change was triggered by our own drag/toggle emit;
                // otherwise the drag would get reset on every interaction.
                if (this.suppressMerge) return;
                if (this.showColumns) {
                    this.columnFields = this.mergeFieldsWithView();
                }
            },
            deep: true,
        },
        fields: {
            handler() {
                if (this.suppressMerge) return;
                if (this.showColumns) {
                    this.columnFields = this.mergeFieldsWithView();
                }
            },
            deep: true,
        },
    },
    methods: {
        mergeFieldsWithView() {
            const fields = Array.isArray(this.fields) ? this.fields : [];
            const rawView = this.viewColumns;
            const viewCols = Array.isArray(rawView)
                ? rawView
                : (rawView && Array.isArray(rawView.columns) ? rawView.columns : []);
            // No view supplied — fall back to each field's own `visible` flag.
            if (!viewCols.length) {
                return fields.map(f => ({ ...f, visible: !!f.visible }));
            }
            // Visibility comes from the `visible` flag on the view's column entries.
            const visibleKeyToDisplay = new Map();
            viewCols.forEach(c => {
                if (c && c.visible) visibleKeyToDisplay.set(c.key, c.display_order);
            });
            // Sort visible keys by display_order (nulls first).
            const visibleSorted = [...visibleKeyToDisplay.entries()]
                .sort((a, b) => {
                    const ao = a[1] == null ? -Infinity : a[1];
                    const bo = b[1] == null ? -Infinity : b[1];
                    return ao - bo;
                })
                .map(([key]) => key);
            const fieldsByKey = new Map(fields.map(f => [f.key, f]));
            const out = [];
            // Visible first, in display order.
            visibleSorted.forEach(key => {
                const f = fieldsByKey.get(key);
                if (f) out.push({ ...f, visible: true });
            });
            // Then remaining catalog columns (unchecked) in catalog order.
            fields.forEach(f => {
                if (!visibleKeyToDisplay.has(f.key)) out.push({ ...f, visible: false });
            });
            return out;
        },
        updateFields() {
            this.suppressMerge = true;
            this.$emit("updateFields", this.columnFields);
            this.$nextTick(() => { this.suppressMerge = false; });
        },
        getUpdatedFieldsList() {
            this.suppressMerge = true;
            this.$emit("getUpdatedFieldsList", this.columnFields);
            this.$nextTick(() => { this.suppressMerge = false; });
        }
    }
}
</script>